module.exports = __webpack_public_path__ + "static/img/1.8d44c2b0.jpg";